import type { WorldManifest } from '../../framework/world/manifest';

/**
 * Development-only template world (never shown to production viewers). Copy this folder to
 * start a new world; see docs/world-authoring.md.
 */
export const TEMPLATE_MANIFEST: WorldManifest = {
  schemaVersion: 1,
  id: 'template',
  version: '0.1.0',
  title: 'Template',
  tagline: 'A minimal world proving the lifecycle contract.',
  description: 'A plain clearing with one stone, the shared light cycle and weather. For development only.',
  moods: ['dev'],
  devOnly: true,
  preview: {
    poster: 'worlds/template/poster.jpg',
    alt: 'A plain grey clearing with a single stone.',
    palette: ['#3a3d36', '#6b6f62'],
  },
  assets: [],
  playlist: {
    id: 'template',
    title: 'Template',
    tracks: [
      {
        id: 'lantern-moss',
        title: 'Lantern Moss',
        artist: 'Glass Box (generated)',
        sources: [{ url: 'audio/mosslight/lantern-moss.mp3', type: 'audio/mpeg' }],
        license: 'gbr-generated-music',
        source: 'Shared interim track (development fixture).',
      },
    ],
  },
  controls: {
    timeModes: ['living', 'local', 'hold'],
    stages: ['dawn', 'morning', 'afternoon', 'golden', 'dusk', 'night'],
    weatherMoods: ['auto', 'clear', 'overcast', 'rain'],
    zoom: [0.9, 1.1],
  },
  quality: {
    battery: { targetFps: 30, maxPixelRatio: 1, detail: 'low' },
    balanced: { targetFps: 60, maxPixelRatio: 1.5, detail: 'medium' },
    high: { targetFps: 60, maxPixelRatio: 2, detail: 'high' },
  },
  residents: [],
  compatibility: { framework: '^1.0', renderer: 'webgl2' },
};
